'use strict';

var React = require('react');

var Icon = React.createClass({
  displayName: 'Icon',

  render: function render() {
    return React.createElement('i', { className: 'fa fa-' + this.props.name });
  }
});

module.exports = Icon;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/icon.js
 **/